import { Model } from '@/models/Model';
export class WhiteLabel extends Model {
    constructor() {
        super(...arguments);
        this.$endpoint = '/whitelabels';
        this.$name = 'WhiteLabel';
        this.$fillable = [
            'name',
            'slug',
            'domain',
            'title',
            'logo_url',
            'logo_small_url',
            'favicon_url',
            'color_primary',
            'color_secondary',
            'helpdesk_label',
            'helpdesk_url',
            'email_from_name',
            'email_from_address',
            'email_footer_text',
            'menu_tabs',
            'translations',
            'is_active',
        ];
    }
    attachSchools(schoolIds) {
        const url = `${this.$endpoint}/${this.resolvePrimaryKey()}/attach-schools`;
        return this.request('post', url, { school_ids: schoolIds });
    }
    detachSchools(schoolIds) {
        const url = `${this.$endpoint}/${this.resolvePrimaryKey()}/detach-schools`;
        return this.request('post', url, { school_ids: schoolIds });
    }
    attachUsers(userIds) {
        const url = `${this.$endpoint}/${this.resolvePrimaryKey()}/attach-users`;
        return this.request('post', url, { user_ids: userIds });
    }
    detachUsers(userIds) {
        const url = `${this.$endpoint}/${this.resolvePrimaryKey()}/detach-users`;
        return this.request('post', url, { user_ids: userIds });
    }
}
export var WhiteLabelIncludes;
(function (WhiteLabelIncludes) {
    WhiteLabelIncludes["SCHOOLS"] = "schools";
    WhiteLabelIncludes["USERS"] = "users";
})(WhiteLabelIncludes || (WhiteLabelIncludes = {}));
